var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[( _vm.useLogo)?_c('div',{staticStyle:{"text-align":"center","display":"flex"}},[(_vm.dataLogo)?_c('img',{staticStyle:{"align-self":"center","margin":"20px auto 32px auto","max-width":"100%","max-height":"100px"},attrs:{"src":_vm.dataLogo}}):_vm._e()]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }